import React from "react"

const PulsingLoader = ({ size = 48 }) => {
  return (
    <div className="relative inline-block" style={{ width: `${size}px`, height: `${size}px` }}>
      <style>{`
        .pulse-container { position: relative; width: ${size}px; height: ${size}px; }
        .pulse-circle {
          position: absolute; top: 0; left: 0;
          width: ${size}px; height: ${size}px;
          border-radius: 50%; background: #DFDFE0;
          transform: scale(0.3); opacity: 0.8;
        }
        .pulse-circle-1 { animation: pulse-expand 2s infinite linear; animation-delay: -1.2s; }
        .pulse-circle-2 { animation: pulse-expand 2s infinite linear; animation-delay: -0.7s; }
        .pulse-circle-3 { animation: pulse-expand 2s infinite linear; animation-delay: -0.2s; }
        @keyframes pulse-expand {
          0%   { transform: scale(0.3); opacity: 0.8; }
          100% { transform: scale(1);   opacity: 0; }
        }
      `}</style>
      <div className="pulse-container">
        <div className="pulse-circle pulse-circle-1"></div>
        <div className="pulse-circle pulse-circle-2"></div>
        <div className="pulse-circle pulse-circle-3"></div>
      </div>
    </div>
  )
}

export default PulsingLoader
